import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";
import {vec4, vec2} from "_src/libs/gl-matrix";

import vertText from "_src/shaders/selection/selection_mask.glslv";
import fragText from "_src/shaders/selection/selection_mask.glslf";

const _vec4Tmp = vec4.create();

const preprocessorRules = {
  "CIRCLE": 0,
  "RECT": 1,
};

export default class SelectionMaskShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms();

  }

  //reimplementation
  initDirectives() {
    this._directives["MODE"] = "CIRCLE";
  }

  compile() {

    super.compile(vertText, fragText, preprocessorRules);

  }

  renderCallback() {
    //NOTE: it's a hack
    const selectionSetting = this.uniforms["u_circle"].value;
    selectionSetting[2] = selectionSetting[0];
    selectionSetting[3] = selectionSetting[1];
    this.dropID();
  }

  updateSceneUniformValues(scene)   {
    const camera = scene.camera;
    vec2.set(this.uniforms["u_viewport"].value, camera.viewport[2], camera.viewport[3]);
  }

  updateObjectUniformValues(object)   {
    vec4.copy(this.uniforms["u_diffuse"].value, object.properties.diffuseColor);
  }

  attachUniforms() {

    const rectangle     = vec4.create();
    const circle        = vec4.create();
    const radius        = 0;
    const diffuseColor  = vec4.create();

    this.uniforms["u_rectangle"] = new Uniform(uniformType.FLOAT4, rectangle);
    this.uniforms["u_circle"]    = new Uniform(uniformType.FLOAT4, circle);
    this.uniforms["u_radius"]    = new Uniform(uniformType.FLOAT1, radius);
    this.uniforms["u_diffuse"]   = new Uniform(uniformType.FLOAT4, diffuseColor, uniformSource.OBJECT);
    this.uniforms["u_viewport"]  = new Uniform(uniformType.FLOAT2, vec2.create(), uniformSource.SCENE);

  }

  setRectangle(x, y, z, w) {
    const rectangle = vec4.set(_vec4Tmp, x, y, z, w);
    this.setUniform("u_rectangle", rectangle);
  }

  setSelectionRadius(radius) {
    this.setUniform("u_radius", radius);
  }

  setFirstPoint(x, y) {
    const selectionSetting = this.uniforms["u_circle"].value;
    selectionSetting[0] = x;
    selectionSetting[1] = y;
    this.setUniform("u_circle", selectionSetting);
  }

  getFirstPoint() {

    const x = this.uniforms["u_circle"].value[0];
    const y = this.uniforms["u_circle"].value[1];

    return [x,y];
  }

  setSecondPoint(x, y) {
    const selectionSetting = this.uniforms["u_circle"].value;
    selectionSetting[2] = x;
    selectionSetting[3] = y;
    this.setUniform("u_circle", selectionSetting);
  }

}
